import { computed } from 'vue';
import { useRoute } from 'vue-router';

const LOGIN_PROCESS_PATH_PATTERNS = [/^\/login$/, /^\/ssologin$/, /^\/user\/mfa\//];

export const matchesLoginProcessPath = (pathname: string): boolean =>
    LOGIN_PROCESS_PATH_PATTERNS.some(pattern => pattern.test(pathname));

export const useIsLoginProcessRoute = () => {
    const route = useRoute();

    return computed(() => matchesLoginProcessPath(route.path));
};
